import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { CommonApiData, initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { autoCompleteDelay } from "../../config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FetchAutoCompleteData, FindTranslatedKey, deleteData } from "../CommonComponents/CustomHooks";
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, handleDownloadExcel, readFile } from "../CommonComponents/ExportData";
import { AutoCompleteBox, FormButton, ImportButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const StateMaster = ({ menuText }) => {
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [HandleChoose, setHandleChoose] = useState(false)
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [Name, setName] = useState('');
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [disableEdit, setDisableEdit] = useState(false)
    const Hide = false;
    const [formData, setFormData] = useState({
        "countryCode": '',
        "stateCode": '',
        "stateID": "",
        "stateName": "",
        "active": true,
    })

    const handleClear = () => {
        setFormData({
            "countryCode": '',
            "stateCode": '',
            "stateID": "",
            "stateName": "",
            "active": true,
        });
        filterData.SearchText = ''
        setStatus([])
        setImportData([])
        getStateMasterData()
        setHandleChoose(false)
        setName(false)
       // inputrefs.current['txtStateCode'].focus();
        BulkClearData(setName)
        setDisableEdit(false)
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Master/InsertUpdateStateMaster', formData)
        await dispatch(setSubLoading(false))
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        }
    }
    const handleDelete = async (ID) => {
        await dispatch(setSubLoading(true))
        await deleteData('/api/Master/DeleteStateMaster', { stateID: ID }, getStateMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    //Start Bulk Upload
    const Data = CommonApiData()
    let IData = {
        ...Data,
        "cityID": "",
    }

    const DownloadFormat = async () => {
        await DownloadFileAtURL('StateMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'StateMasterError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
        let a = document.querySelectorAll('.bulk-upload');
        if (a.length > 0) {
            a[0].childNodes[2].innerHTML = data.FileName;
        }
    };

    const handleBulk = async () => {
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("CountryCode", "StateCode", "StateName", "IsActive")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Master/InsertUpdateStateMaster', ImportData, IData, getStateMasterData)
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }
    //End Bulk Upload
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleEdit = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/Master/EditStateMaster', { stateID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR'|| editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setDisableEdit(true)
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }
    }

    let PageName = "StateMaster"

    const getStateMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Master/ShowStateMaster', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getStateMasterData(value);
    };
    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };

    useEffect(() => {
        getStateMasterData();
    }, [sortConfig])

    useEffect(() => {
       // inputrefs.current['txtStateCode'].focus();
        document.title = 'State Master'
    }, [])
    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText :  FindTranslatedKey('State Master')}</h6>
                </div>
                <div className='card-body row'>
                    <div className='col-md-6 col-lg-8'>
                       {/* {Hide ? <>*/}
                            <div className='row'>
                                <InputBox
                                    divclassname='col-md-4 col-sm-6 mb-3'
                                    label='State Code'
                                  PlaceHolderText='State Code'
                                    required={true}
                                    inputrefs={inputrefs}
                                    id='txtStateCode'
                                    disabled={disableEdit}
                                    value={formData.stateCode}
                                    maxLength='50'
                                    onChange={(e) => {
                                        setFormData({ ...formData, stateCode: e.target.value })
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtStateName'].focus();
                                        }
                                    }}
                                />

                                <InputBox
                                    divclassname='col-md-4 col-sm-6 mb-3'
                                    label='State Name'
                                    PlaceHolderText='State Name'
                                    required={true}
                                    inputrefs={inputrefs}
                                    id='txtStateName'
                                    value={formData.stateName}
                                    maxLength='50'
                                    onChange={(e) => {
                                        setFormData({ ...formData, stateName: e.target.value })
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtCountry'].focus();
                                        }
                                    }}
                                />
                                <AutoCompleteBox
                                    divclassname='col-md-4 col-sm-6 mb-3'
                                    label='Country'
                                    placeholder='Country'
                                    inputValue={formData.countryCode ? formData.countryCode : ''}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, '', 'GetCountry');
                                            setFormData({ ...formData, countryCode: newInputValue })
                                        }}
                                    maxLength='50'
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    required={true}
                                    inputrefs={inputrefs}
                                    id='txtCountry'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtActive'].focus() };
                                    }}
                                />

                                <Switch
                                    label='Active'
                                    extraclassname='form-check form-switch ps-4 me-2'
                                    inputrefs={inputrefs}
                                    id='txtActive'
                                    checked={formData.active}
                                    onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['btnSave'].focus() };
                                    }}
                                />
                            </div>
                        {/*</> : <></>}*/}
                      
                        <div className='row pb-1'>
                            <FormButton
                                id='btnSave'
                                inputrefs={inputrefs}
                                handleSubmit={handleSubmit}
                                //save={false}
                                handleExport={async () => {
                                    await dispatch(setSubLoading(true))
                                    await handleDownloadExcel('/api/Master/ShowStateMaster', filterData, 'State Master')
                                    await dispatch(setSubLoading(false))
                                }}
                                importData={true}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                handleBulk={handleBulk}
                                UploadState={HandleChoose}
                                FileName={Name}
                                downloadFormat={DownloadFormat}
                                HandleChoose={() => setHandleChoose(!HandleChoose)}
                                handleClear={handleClear} />

                        </div>
                    </div>
                   {/* {Hide ? <>*/}
                        <div className='d-flex col-md-6 col-lg-4 h-25'>
                            <ImportButton
                                handleBulk={handleBulk}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                downloadFormat={DownloadFormat}
                                ErrorData={ErrorData}
                                Status={Status}
                                HeaderFormat="PayMode, Active"
                                fileName={Name}
                            >
                            </ImportButton>
                        </div>
                    {/*</> : <></>}*/}
                    <Table handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        PageName={PageName}
                        loading={loading}
                        handleFilter={() => {
                            getStateMasterData()
                            setFilterData({
                                ...filterData,
                            })
                        }}
                        filterData={filterData}
                        tableData={result}
                        setFilterData={setFilterData}
                        currentPageNo={currentPageNo}
                        handleChange1={handleChange1}
                        handleSorting={handleSorting}
                        sortConfig={sortConfig}
                    />
                </div>
            </div>

           
        </>
    )
}

export default StateMaster